import qs from 'qs';
import React from 'react';
import { Route, Routes, useNavigate, useResolvedPath } from 'react-router-dom';
import { useAppointmentState } from '../../context/Appointment/appointment';
import { useKioskState } from '../../context/Kiosk/kiosk';
import { Comments } from './Comments';
import { SkipServices } from './SkipServices/SkipServices';
import { StandardServices } from './Standard';
import { XtimeServices } from './XTime/XTimeServices';
import { Appointment_ServiceRoutePaths, PathName } from '../../helpers/Routes';

export interface IProps {
    onProceed: () => void;
    onSkip: () => void;
}

export const Services: React.FC<IProps> = React.memo((props) => {
    const navigate = useNavigate();
    const {
        dealer: { xtimeEnabled, serviceCommentsEnabled },
    } = useKioskState();
    const { pathname } = useResolvedPath('.');
    const appointment = useAppointmentState();
    const [xtimeError, setXtimeError] = React.useState(false);
    const navigateToComments = () => {
        if (serviceCommentsEnabled) {
            navigate(PathName(pathname, Appointment_ServiceRoutePaths.Comments));
        }
        else {
            props.onProceed();
        }
    };

    return (
        <Routes>
            <Route
                path={''}
                element={
                    <SkipServices
                        onProceed={(needsServices, typeComments) => {
                            if (needsServices) {
                                navigate(PathName(pathname, `${Appointment_ServiceRoutePaths.Add}?${qs.stringify({ showCommentsTab: typeComments })}`));
                            }
                            else {
                                props.onProceed();
                            }
                        }}
                        onDisabled={() => {
                            navigate(PathName(pathname, Appointment_ServiceRoutePaths.Add), { replace: true });
                        }}
                    />
                }
            />
            <Route
                path={PathName(Appointment_ServiceRoutePaths.Add, '*')}
                element={
                    appointment.vin && xtimeEnabled && !xtimeError ? (
                        <XtimeServices onProceed={navigateToComments} onError={() => setXtimeError(true)} />
                    ) : (
                        <StandardServices onProceed={navigateToComments} />
                    )
                }
            />
            <Route path={PathName(Appointment_ServiceRoutePaths.Comments, '*')} element={<Comments onProceed={props.onProceed} onSkip={props.onSkip} />} />
        </Routes>
    );
});
